<div class="form-group" [formGroup]="customFormGroup">
  <label [for]="'select-'+id" [id]="'sfklabel-'+id" data-cy="custom-label">
    {{label}}
  </label>
  @if (!!infoText && infoText.length > 0) {
    <fa-icon class="infoIcon"
      [icon]="faInfo"
      [title]="infoText"
      data-cy="custom-info"
    ></fa-icon>
  }
  @if (environment.displayTextbausteinKeys) {
    <span>{{infoText}}</span>
  }
  <ng-select
    [labelForId]="'select-' + id"
    [attr.aria-label]="'Select Box ' + id"
    [items]="items"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [multiple]="multiple"
    [closeOnSelect]="!multiple"
    [searchable]= "searchable"
    [clearable]= "clearable"
    [placeholder]="placeholder"
    [formControlName]="id"
    [readonly]="readonly ? true : null"
    [notFoundText]="notfoundtext"
    [loading]="loading"
    [loadingText]="loadingText"
    [hideSelected]="hideSelected"
    [virtualScroll]="true"
    (change)="triggerOnChange($event)"
    (search)="triggerSearch($event)"
    (scrollToEnd)="triggerScrollToEnd($event)"
    (open)="triggerOpen($event)"
    (clear)="triggerOnClear()"
    data-cy="custom-select"
    >

    <!--	 Template to display currently selected item (single select)-->
    <ng-template ng-label-tmp let-item="item">
      <!-- if template given, display via custom template, otherwise display item[bindLabel] by default -->
      @if (!customStringTemplate) {
        <span class="ng-value-label"><span [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]"><ng-container *ngTemplateOutlet="bindlabeltemplate; context: {item: item}"></ng-container></span></span>
      }
      @if (customStringTemplate) {
        <span class="ng-value-label" [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]"><ng-container *ngTemplateOutlet="customStringTemplate; context: {item: item}"></ng-container></span>
      }
    </ng-template>

    <!--	 Template to display currently selected items (multi select)-->
    @if (this.placeholderAlwaysVisible===true; as items) {
      <ng-template ng-multi-label-tmp let-items="items">
        @for (item of items ; track item) {
          <div class="ng-value">
            <span class="ng-value-icon right" (click)="clearItem(item)" aria-hidden="true">×</span>
            <!-- if template given, display via custom template, otherwise display item[bindLabel] by default -->
            @if (!customStringTemplate) {
              <span class="ng-value-label"><span [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]"><ng-container *ngTemplateOutlet="bindlabeltemplate; context: {item: item}"></ng-container></span></span>
            }
            @if (customStringTemplate) {
              <span class="ng-value-label" [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]"><ng-container *ngTemplateOutlet="customStringTemplate; context: {item: item}"></ng-container></span>
            }
          </div>
        }
        <div class="ng-value" style="background: none;"><span class="ng-value-label text-muted">{{this.placeholder}}</span></div>
      </ng-template>
    }

    <!--	 Template to display Option items inside the dropdown (applied for both, multi select and single select)-->
    <ng-template ng-option-tmp let-item="item">
      <!-- if template given, display via custom template, otherwise display item[bindLabel] by default -->
      @if (!customStringTemplate) {
        <span class="ng-value-label"><span [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]"><ng-container *ngTemplateOutlet="bindlabeltemplate; context: {item: item}"></ng-container></span></span>
      }
      @if (customStringTemplate) {
        <span class="ng-value-label" [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]"><ng-container *ngTemplateOutlet="customStringTemplate; context: {item: item}"></ng-container></span>
      }
    </ng-template>

  </ng-select>


  <!--  the following template is used to render the actual label-->
  <ng-template #bindlabeltemplate let-item="item">
    <!-- NOTE: condensed markup to avoid whitespace text nodes between inline spans -->
    <span [attr.aria-label]="item[bindLabel]" [title]="item[bindLabel]">
      @switch (getDataType(item)) {
        @case ('null') {
          {{ "-" }}
        }
        @case ('undefined') {
          {{ "-" }}
        }
        @case ('string') {
          {{ item === "" ? "-" : item }}
        }
        @case ('number') {
          {{ item }}
        }
        @default {
          <span>@switch (getDataType(item[bindLabel])) {
            @case ('null') { {{ "-" }} }
            @case ('undefined') { {{ "-" }} }
            @case ('string') { {{ item[bindLabel] === "" ? "-" : item[bindLabel] }} }
            @case ('number') { {{ item[bindLabel] }} }
            @default { <!--fallbacks-->{{ ( !!item["value"] ? item["value"] : ( !!item["name"] ? item["name"] : ( !!item ? item : ( item ) ) ) ) }} }
          }</span>
        }
      }
    </span>
  </ng-template>
            @if (isInvalid()) {
              <small
                [id]="id + '-help-block'"
                class="form-text text-muted"
                >
                {{ noteText }}
              </small>
            }
            @if (!!infoTextBelowInput && infoTextBelowInput.length > 0) {
              <p>
                {{ infoTextBelowInput }}
              </p>
            }
          </div>
